import * as v from "valibot";

export const ADMIN_PARAM_MAX_VALUE_CHARS = 4096;

export const adminParamDto = v.object({
  name: v.string(),
  /** A SecureString: its value is never listed, only whether it is set and (on request) a masked preview. */
  secure: v.boolean(),
  /** Whether this page may write it; the rest are set by Terraform or a deploy script. */
  editable: v.boolean(),
  set: v.boolean(),
  /** The value of a plain parameter; null for a secure or unset one. */
  value: v.nullable(v.string()),
  updatedAt: v.nullable(v.number()),
});
export type AdminParam = v.InferOutput<typeof adminParamDto>;

export const getAdminParamsResponse = {
  prefix: v.string(),
  params: v.array(adminParamDto),
};

export type GetAdminParamsResponse = v.InferOutput<v.ObjectSchema<typeof getAdminParamsResponse, undefined>>;

export const adminParamNameRequest = {
  name: v.pipe(v.string(), v.minLength(1), v.maxLength(128)),
};

export const getAdminParamValueResponse = {
  /** The first and last characters of a secure value, never the whole of it. */
  preview: v.string(),
};

export const putAdminParamRequest = {
  name: v.pipe(v.string(), v.minLength(1), v.maxLength(128)),
  value: v.pipe(v.string(), v.minLength(1, "Enter a value"), v.maxLength(ADMIN_PARAM_MAX_VALUE_CHARS)),
};
